import React, { useState } from 'react';

const Recruitment = ({ userRole = 'hr', onAddRecruitment }) => {
  const [activeTab, setActiveTab] = useState('jobs');
  const [showJobForm, setShowJobForm] = useState(false);
  const [showCandidateForm, setShowCandidateForm] = useState(false);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [showInterviewModal, setShowInterviewModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [currentFeedbackRound, setCurrentFeedbackRound] = useState(null);
  // Validation error state for the job form
  const [jobFormErrors, setJobFormErrors] = useState({});
  // Validation errors for candidate form
  const [candidateFormErrors, setCandidateFormErrors] = useState({});

  // Job Postings State
  const [jobs, setJobs] = useState([
    {
      id: 1,
      title: 'Senior Software Engineer',
      department: 'IT',
      location: 'Mumbai',
      experience: '5-8 years',
      salaryMin: 1200000,
      salaryMax: 1800000,
      type: 'Full-time',
      openings: 2,
      status: 'Open',
      postedDate: '2024-01-15',
      deadline: '2025-03-15',
      description: 'Looking for experienced software engineer with React and Node.js skills',
      requirements: ['React.js', 'Node.js', 'MongoDB', 'AWS'],
    },
    {
      id: 2,
      title: 'HR Executive',
      department: 'HR',
      location: 'Delhi',
      experience: '2-4 years',
      salaryMin: 400000,
      salaryMax: 600000,
      type: 'Full-time',
      openings: 1,
      status: 'Open',
      postedDate: '2024-02-01',
      deadline: '2025-03-01',
      description: 'Handle recruitment, employee relations, and HR operations',
      requirements: ['HR Management', 'Recruitment', 'Employee Relations', 'MS Office'],
    },
  ]);

  // Role-wise Designations
  const roleDesignations = {
    'Technical Lead': ['Amit Sharma', 'Rajesh Verma', 'Sneha Patil'],
    'Senior Developer': ['Priya Patel', 'Kunal Mehta', 'Divya Nair'],
    'HR Manager': ['Neha Gupta', 'Sanjay Singh', 'Pooja Reddy'],
    'Product Manager': ['Rahul Khanna', 'Anjali Desai', 'Vikram Singh'],
    'QA Lead': ['Manish Joshi', 'Swati Kulkarni', 'Ravi Kumar']
  };

  // Candidates State with 4 Interview Rounds
  const [candidates, setCandidates] = useState([
    {
      id: 1,
      name: 'Rajesh Kumar',
      email: 'rajesh@email.com',
      phone: '9876543210',
      position: 'Senior Software Engineer',
      experience: '6 years',
      currentCtc: 1400000,
      expectedCtc: 1800000,
      status: 'Round 2 Scheduled',
      appliedDate: '2024-02-10',
      resume: 'resume_rajesh.pdf',
      skills: ['React', 'Node.js', 'Python'],
      interviewRounds: [
        {
          round: 1,
          name: 'Technical Screening',
          interviewerName: 'Amit Sharma',
          interviewerDesignation: 'Technical Lead',
          date: '2025-02-15',
          time: '10:00 AM',
          duration: '2 hours',
          feedback: {
            technicalSkills: 8,
            communication: 7,
            problemSolving: 8,
            overall: 'Good candidate',
            status: 'Passed'
          },
          status: 'Completed'
        },
        {
          round: 2,
          name: 'Technical Coding',
          interviewerName: 'Priya Patel',
          interviewerDesignation: 'Senior Developer',
          date: '2025-02-20',
          time: '11:00 AM',
          duration: '2 hours',
          feedback: null,
          status: 'Scheduled'
        },
        {
          round: 3,
          name: 'System Design',
          interviewerName: '',
          interviewerDesignation: '',
          date: '',
          time: '',
          duration: '2 hours',
          feedback: null,
          status: 'Pending'
        },
        {
          round: 4,
          name: 'HR Discussion',
          interviewerName: '',
          interviewerDesignation: '',
          date: '',
          time: '',
          duration: '2 hours',
          feedback: null,
          status: 'Pending'
        }
      ]
    },
    {
      id: 2,
      name: 'Priya Sharma',
      email: 'priya@email.com',
      phone: '9876543211',
      position: 'HR Executive',
      experience: '3 years',
      currentCtc: 450000,
      expectedCtc: 550000,
      status: 'Round 1 Completed',
      appliedDate: '2024-02-12',
      resume: 'resume_priya.pdf',
      skills: ['Recruitment', 'Onboarding', 'HR Policies'],
      interviewRounds: [
        {
          round: 1,
          name: 'HR Screening',
          interviewerName: 'Neha Gupta',
          interviewerDesignation: 'HR Manager',
          date: '2025-02-18',
          time: '2:00 PM',
          duration: '2 hours',
          feedback: {
            communication: 9,
            hrKnowledge: 8,
            attitude: 9,
            overall: 'Excellent communication skills',
            status: 'Passed'
          },
          status: 'Completed'
        },
        {
          round: 2,
          name: 'HR Operations',
          interviewerName: '',
          interviewerDesignation: '',
          date: '',
          time: '',
          duration: '2 hours',
          feedback: null,
          status: 'Pending'
        },
        {
          round: 3,
          name: 'Client Coordination',
          interviewerName: '',
          interviewerDesignation: '',
          date: '',
          time: '',
          duration: '2 hours',
          feedback: null,
          status: 'Pending'
        },
        {
          round: 4,
          name: 'Final HR Round',
          interviewerName: '',
          interviewerDesignation: '',
          date: '',
          time: '',
          duration: '2 hours',
          feedback: null,
          status: 'Pending'
        }
      ]
    }
  ]);

  // New Job Form State
  const [newJob, setNewJob] = useState({
    title: '',
    department: '',
    location: '',
    experience: '',
    salaryMin: '',
    salaryMax: '',
    type: 'Full-time',
    openings: '',
    deadline: '',
    description: '',
    requirements: '',
  });

  // New Candidate Form State
  const [newCandidate, setNewCandidate] = useState({
    name: '',
    email: '',
    phone: '',
    position: '',
    experience: '',
    currentCtc: '',
    expectedCtc: '',
    skills: '',
    resume: null,
  });

  // Interview Schedule State
  const [interviewData, setInterviewData] = useState({
    candidateId: null,
    round: 1,
    roundName: '',
    interviewerName: '',
    interviewerDesignation: '',
    date: '',
    time: '',
    duration: '2 hours',
  });

  // Feedback Form State
  const [feedbackData, setFeedbackData] = useState({
    technicalSkills: 5,
    communication: 5,
    problemSolving: 5,
    attitude: 5,
    domainKnowledge: 5,
    overall: '',
    status: 'Passed',
    additionalComments: ''
  });

  const departments = ['IT', 'HR', 'Marketing', 'Sales', 'Finance', 'Operations'];
  const jobTypes = ['Full-time', 'Part-time', 'Contract', 'Internship'];
  const roundNames = {
    1: '1st Round - Technical/Screening',
    2: '2nd Round - Technical/Coding',
    3: '3rd Round - System Design/Managerial',
    4: '4th Round - HR/Final Discussion'
  };

  // --- Helper: Truncate text to limit (for candidate view) ---
  const truncateText = (text, limit = 100) => {
    if (!text) return '';
    return text.length > limit ? text.substring(0, limit) + '...' : text;
  };

  // --- Validation Functions for Job Form ---
  const validateTextField = (value, fieldName) => {
    if (value.length > 100) {
      return `${fieldName} cannot exceed 100 characters.`;
    }
    return null;
  };

  const validatePositiveInteger = (value, fieldName) => {
    const num = Number(value);
    if (isNaN(num) || !Number.isInteger(num) || num <= 0) {
      return `${fieldName} must be a positive integer.`;
    }
    return null;
  };

  const validateSalary = (value, fieldName) => {
    const num = Number(value);
    if (isNaN(num) || num <= 0) {
      return `${fieldName} must be a positive number.`;
    }
    return null;
  };

  const validateDeadline = (dateString) => {
    if (!dateString) return "Deadline is required.";
    const selectedDate = new Date(dateString);
    const minDate = new Date('2025-01-01');
    const maxDate = new Date('2026-12-31');
    if (selectedDate < minDate) {
      return "Deadline cannot be before the year 2025.";
    }
    if (selectedDate > maxDate) {
      return "Deadline cannot be after the year 2026.";
    }
    return null;
  };

  const validateJobForm = () => {
    const errors = {};
    
    const titleError = validateTextField(newJob.title, 'Job Title');
    if (titleError) errors.title = titleError;
    
    const locationError = validateTextField(newJob.location, 'Location');
    if (locationError) errors.location = locationError;
    
    const expError = validateTextField(newJob.experience, 'Experience');
    if (expError) errors.experience = expError;
    
    if (!newJob.department) errors.department = 'Department is required.';
    
    const minSalaryError = validateSalary(newJob.salaryMin, 'Min Salary');
    if (minSalaryError) errors.salaryMin = minSalaryError;
    
    const maxSalaryError = validateSalary(newJob.salaryMax, 'Max Salary');
    if (maxSalaryError) errors.salaryMax = maxSalaryError;
    
    if (!errors.salaryMin && !errors.salaryMax && Number(newJob.salaryMin) >= Number(newJob.salaryMax)) {
      errors.salaryMax = 'Max Salary must be greater than Min Salary.';
    }
    
    const openingsError = validatePositiveInteger(newJob.openings, 'Openings');
    if (openingsError) errors.openings = openingsError;
    
    const deadlineError = validateDeadline(newJob.deadline);
    if (deadlineError) errors.deadline = deadlineError;
    
    setJobFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // --- Validation Functions for Candidate Form ---
  const validatePhoneNumber = (phone) => {
    const phoneRegex = /^\d{10}$/;
    if (!phone) return 'Phone number is required.';
    if (!phoneRegex.test(phone)) return 'Phone number must be exactly 10 digits.';
    return null;
  };

  const validateCandidateDate = (dateString) => {
    if (!dateString) return null; // Date is optional in candidate form
    const selectedDate = new Date(dateString);
    const minDate = new Date('2025-01-01');
    const maxDate = new Date('2026-12-31');
    if (selectedDate < minDate) return "Date cannot be before the year 2025.";
    if (selectedDate > maxDate) return "Date cannot be after the year 2026.";
    return null;
  };

  const validateCandidateForm = () => {
    const errors = {};
    if (!newCandidate.name) errors.name = 'Name is required.';
    if (!newCandidate.email) errors.email = 'Email is required.';
    const phoneError = validatePhoneNumber(newCandidate.phone);
    if (phoneError) errors.phone = phoneError;
    if (!newCandidate.position) errors.position = 'Position is required.';
    if (!newCandidate.experience) errors.experience = 'Experience is required.';
    if (!newCandidate.currentCtc) errors.currentCtc = 'Current CTC is required.';
    if (!newCandidate.expectedCtc) errors.expectedCtc = 'Expected CTC is required.';
    if (!newCandidate.skills) errors.skills = 'Skills are required.';
    setCandidateFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const formatCurrency = (amount) => {
    if (!amount) return '₹0';
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  };

  const showSuccess = (message) => {
    setSuccessMessage(message);
    setTimeout(() => setSuccessMessage(''), 3000);
  };

  const showError = (message) => {
    setErrorMessage(message);
    setTimeout(() => setErrorMessage(''), 3000);
  };

  const handleJobSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateJobForm()) {
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      const jobData = {
        id: Date.now(),
        ...newJob,
        salaryMin: parseFloat(newJob.salaryMin),
        salaryMax: parseFloat(newJob.salaryMax),
        openings: parseInt(newJob.openings, 10),
        postedDate: new Date().toISOString().split('T')[0],
        status: 'Open',
        requirements: newJob.requirements ? newJob.requirements.split(',').map(r => r.trim()) : [],
      };
      
      setJobs([jobData, ...jobs]);
      if (onAddRecruitment) {
        await onAddRecruitment({ type: 'job', data: jobData });
      }
      
      setNewJob({
        title: '',
        department: '',
        location: '',
        experience: '',
        salaryMin: '',
        salaryMax: '',
        type: 'Full-time',
        openings: '',
        deadline: '',
        description: '',
        requirements: '',
      });
      setJobFormErrors({});
      setShowJobForm(false);
      showSuccess('Job posted successfully!');
    } catch (error) {
      showError('Failed to post job');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCandidateSubmit = async (e) => {
    e.preventDefault();
    
    // Validate candidate form including phone
    if (!validateCandidateForm()) {
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      const interviewRounds = [];
      for (let i = 1; i <= 4; i++) {
        interviewRounds.push({
          round: i,
          name: i === 1 ? 'Technical Screening' :
                i === 2 ? 'Technical Coding' :
                i === 3 ? 'System Design' : 'HR Discussion',
          interviewerName: '',
          interviewerDesignation: '',
          date: '',
          time: '',
          duration: '2 hours',
          feedback: null,
          status: 'Pending'
        });
      }

      const candidateData = {
        id: Date.now(),
        name: newCandidate.name,
        email: newCandidate.email,
        phone: newCandidate.phone,
        position: newCandidate.position,
        experience: newCandidate.experience,
        currentCtc: parseFloat(newCandidate.currentCtc) || 0,
        expectedCtc: parseFloat(newCandidate.expectedCtc) || 0,
        appliedDate: new Date().toISOString().split('T')[0],
        status: 'Pending Review',
        skills: newCandidate.skills ? newCandidate.skills.split(',').map(s => s.trim()) : [],
        interviewRounds: interviewRounds,
      };
      
      setCandidates([candidateData, ...candidates]);
      if (onAddRecruitment) {
        await onAddRecruitment({ type: 'candidate', data: candidateData });
      }
      
      setNewCandidate({
        name: '',
        email: '',
        phone: '',
        position: '',
        experience: '',
        currentCtc: '',
        expectedCtc: '',
        skills: '',
        resume: null,
      });
      setCandidateFormErrors({});
      setShowCandidateForm(false);
      showSuccess('Candidate application added successfully!');
    } catch (error) {
      showError('Failed to add candidate');
    } finally {
      setIsSubmitting(false);
    }
  };

  const openScheduleModal = (candidate, round) => {
    setSelectedCandidate(candidate);
    setInterviewData({
      candidateId: candidate.id,
      round: round,
      roundName: roundNames[round],
      interviewerName: candidate.interviewRounds[round-1]?.interviewerName || '',
      interviewerDesignation: candidate.interviewRounds[round-1]?.interviewerDesignation || '',
      date: candidate.interviewRounds[round-1]?.date || '',
      time: candidate.interviewRounds[round-1]?.time || '',
      duration: '2 hours',
    });
    setShowInterviewModal(true);
  };

  const scheduleInterview = () => {
    if (!interviewData.interviewerName || !interviewData.interviewerDesignation || !interviewData.date || !interviewData.time) {
      showError('Please fill all interview details');
      return;
    }

    // Validate interview date is between 2025 and 2026
    const interviewDateError = validateCandidateDate(interviewData.date);
    if (interviewDateError) {
      showError(interviewDateError);
      return;
    }

    const updatedCandidates = candidates.map(candidate => {
      if (candidate.id === interviewData.candidateId) {
        const updatedRounds = [...candidate.interviewRounds];
        updatedRounds[interviewData.round - 1] = {
          ...updatedRounds[interviewData.round - 1],
          interviewerName: interviewData.interviewerName,
          interviewerDesignation: interviewData.interviewerDesignation,
          date: interviewData.date,
          time: interviewData.time,
          duration: interviewData.duration,
          status: 'Scheduled',
        };
        
        return {
          ...candidate,
          interviewRounds: updatedRounds,
          status: `Round ${interviewData.round} Scheduled`,
        };
      }
      return candidate;
    });
    
    setCandidates(updatedCandidates);
    setShowInterviewModal(false);
    showSuccess(`Round ${interviewData.round} interview scheduled successfully!`);
  };

  const openFeedbackModal = (candidate, round) => {
    setSelectedCandidate(candidate);
    setCurrentFeedbackRound(round);
    setFeedbackData({
      technicalSkills: 5,
      communication: 5,
      problemSolving: 5,
      attitude: 5,
      domainKnowledge: 5,
      overall: '',
      status: 'Passed',
      additionalComments: ''
    });
    setShowFeedbackModal(true);
  };

  const submitFeedback = () => {
    const totalScore = (
      feedbackData.technicalSkills +
      feedbackData.communication +
      feedbackData.problemSolving +
      feedbackData.attitude +
      feedbackData.domainKnowledge
    ) / 5;

    const feedback = {
      technicalSkills: feedbackData.technicalSkills,
      communication: feedbackData.communication,
      problemSolving: feedbackData.problemSolving,
      attitude: feedbackData.attitude,
      domainKnowledge: feedbackData.domainKnowledge,
      averageScore: totalScore,
      overall: feedbackData.overall || (totalScore >= 7 ? 'Good candidate' : totalScore >= 5 ? 'Average' : 'Needs improvement'),
      status: feedbackData.status,
      additionalComments: feedbackData.additionalComments,
      submittedAt: new Date().toLocaleString()
    };

    const updatedCandidates = candidates.map(candidate => {
      if (candidate.id === selectedCandidate.id) {
        const updatedRounds = [...candidate.interviewRounds];
        updatedRounds[currentFeedbackRound - 1] = {
          ...updatedRounds[currentFeedbackRound - 1],
          feedback: feedback,
          status: 'Completed',
        };
        
        let newStatus = candidate.status;
        if (feedbackData.status === 'Passed' && currentFeedbackRound < 4) {
          newStatus = `Round ${currentFeedbackRound + 1} Pending`;
        } else if (feedbackData.status === 'Passed' && currentFeedbackRound === 4) {
          newStatus = 'Selected - Offer Pending';
        } else if (feedbackData.status === 'Failed') {
          newStatus = 'Rejected';
        }
        
        return {
          ...candidate,
          interviewRounds: updatedRounds,
          status: newStatus,
        };
      }
      return candidate;
    });
    
    setCandidates(updatedCandidates);
    setShowFeedbackModal(false);
    showSuccess(`Feedback for Round ${currentFeedbackRound} submitted successfully!`);
  };

  const getStatusColor = (status) => {
    if (!status) return 'bg-gray-100 text-gray-800';
    if (status.includes('Open')) return 'bg-green-100 text-green-800';
    if (status.includes('Closed')) return 'bg-red-100 text-red-800';
    if (status.includes('Rejected')) return 'bg-red-100 text-red-800';
    if (status.includes('Selected')) return 'bg-green-100 text-green-800';
    if (status.includes('Scheduled')) return 'bg-purple-100 text-purple-800';
    if (status.includes('Completed')) return 'bg-blue-100 text-blue-800';
    if (status.includes('Pending')) return 'bg-yellow-100 text-yellow-800';
    return 'bg-gray-100 text-gray-800';
  };

  const getRoundStatusColor = (status) => {
    switch(status) {
      case 'Completed': return 'text-green-600';
      case 'Scheduled': return 'text-blue-600';
      case 'Pending': return 'text-gray-400';
      default: return 'text-gray-400';
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-6 sm:py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-6 sm:mb-8">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">Recruitment Management</h1>
          <p className="text-sm text-gray-500 mt-1">Manage job postings and candidates with 4-round interview process (2 hours each round)</p>
        </div>

        {/* Success/Error Messages */}
        {successMessage && (
          <div className="mb-4 bg-green-50 border-l-4 border-green-500 p-4 rounded">
            <p className="text-sm text-green-700">{successMessage}</p>
          </div>
        )}
        {errorMessage && (
          <div className="mb-4 bg-red-50 border-l-4 border-red-500 p-4 rounded">
            <p className="text-sm text-red-700">{errorMessage}</p>
          </div>
        )}

        {/* Tabs */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden mb-6">
          <div className="border-b border-gray-200">
            <nav className="flex space-x-4 sm:space-x-8 px-4 sm:px-6 overflow-x-auto">
              <button
                onClick={() => setActiveTab('jobs')}
                className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors duration-200 ${
                  activeTab === 'jobs'
                    ? 'border-blue-600 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700'
                }`}
              >
                📋 Job Postings
              </button>
              <button
                onClick={() => setActiveTab('candidates')}
                className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors duration-200 ${
                  activeTab === 'candidates'
                    ? 'border-blue-600 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700'
                }`}
              >
                👥 Candidates & Interview Rounds
              </button>
            </nav>
          </div>
        </div>

        {/* Job Postings Tab */}
        {activeTab === 'jobs' && (
          <div>
            <div className="mb-6 flex justify-end">
              <button
                onClick={() => setShowJobForm(!showJobForm)}
                className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition-colors duration-200 flex items-center gap-2"
              >
                <span>+</span> Post New Job
              </button>
            </div>

            {showJobForm && (
              <div className="bg-white rounded-lg shadow-md p-6 mb-6">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">Post New Job Opening</h2>
                <form onSubmit={handleJobSubmit} className="space-y-4">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Job Title *</label>
                      <input 
                        type="text" 
                        required 
                        maxLength="100"
                        value={newJob.title} 
                        onChange={(e) => {
                          setNewJob({...newJob, title: e.target.value});
                          if (jobFormErrors.title) setJobFormErrors({...jobFormErrors, title: null});
                        }} 
                        className={`w-full px-3 py-2 border rounded-md ${jobFormErrors.title ? 'border-red-500' : 'border-gray-300'}`} 
                      />
                      {jobFormErrors.title && <p className="text-red-500 text-xs mt-1">{jobFormErrors.title}</p>}
                      <p className="text-gray-400 text-xs mt-1">{newJob.title.length}/100 characters</p>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Department *</label>
                      <select required value={newJob.department} onChange={(e) => setNewJob({...newJob, department: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-md">
                        <option value="">Select Department</option>
                        {departments.map(dept => <option key={dept} value={dept}>{dept}</option>)}
                      </select>
                      {jobFormErrors.department && <p className="text-red-500 text-xs mt-1">{jobFormErrors.department}</p>}
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Location *</label>
                      <input 
                        type="text" 
                        required 
                        maxLength="100"
                        value={newJob.location} 
                        onChange={(e) => {
                          setNewJob({...newJob, location: e.target.value});
                          if (jobFormErrors.location) setJobFormErrors({...jobFormErrors, location: null});
                        }} 
                        className={`w-full px-3 py-2 border rounded-md ${jobFormErrors.location ? 'border-red-500' : 'border-gray-300'}`} 
                      />
                      {jobFormErrors.location && <p className="text-red-500 text-xs mt-1">{jobFormErrors.location}</p>}
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Experience Required *</label>
                      <input 
                        type="text" 
                        required 
                        maxLength="100"
                        value={newJob.experience} 
                        onChange={(e) => {
                          setNewJob({...newJob, experience: e.target.value});
                          if (jobFormErrors.experience) setJobFormErrors({...jobFormErrors, experience: null});
                        }} 
                        className={`w-full px-3 py-2 border rounded-md ${jobFormErrors.experience ? 'border-red-500' : 'border-gray-300'}`} 
                      />
                      {jobFormErrors.experience && <p className="text-red-500 text-xs mt-1">{jobFormErrors.experience}</p>}
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Min Salary (₹) *</label>
                      <input 
                        type="number" 
                        required 
                        min="1"
                        step="1"
                        value={newJob.salaryMin} 
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value === '' || parseInt(value) > 0) {
                            setNewJob({...newJob, salaryMin: value});
                            if (jobFormErrors.salaryMin) setJobFormErrors({...jobFormErrors, salaryMin: null});
                          }
                        }} 
                        className={`w-full px-3 py-2 border rounded-md ${jobFormErrors.salaryMin ? 'border-red-500' : 'border-gray-300'}`} 
                      />
                      {jobFormErrors.salaryMin && <p className="text-red-500 text-xs mt-1">{jobFormErrors.salaryMin}</p>}
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Max Salary (₹) *</label>
                      <input 
                        type="number" 
                        required 
                        min="1"
                        step="1"
                        value={newJob.salaryMax} 
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value === '' || parseInt(value) > 0) {
                            setNewJob({...newJob, salaryMax: value});
                            if (jobFormErrors.salaryMax) setJobFormErrors({...jobFormErrors, salaryMax: null});
                          }
                        }} 
                        className={`w-full px-3 py-2 border rounded-md ${jobFormErrors.salaryMax ? 'border-red-500' : 'border-gray-300'}`} 
                      />
                      {jobFormErrors.salaryMax && <p className="text-red-500 text-xs mt-1">{jobFormErrors.salaryMax}</p>}
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Job Type *</label>
                      <select required value={newJob.type} onChange={(e) => setNewJob({...newJob, type: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-md">
                        {jobTypes.map(type => <option key={type} value={type}>{type}</option>)}
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Number of Openings *</label>
                      <input 
                        type="number" 
                        required 
                        min="1"
                        step="1"
                        value={newJob.openings} 
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value === '' || parseInt(value) > 0) {
                            setNewJob({...newJob, openings: value});
                            if (jobFormErrors.openings) setJobFormErrors({...jobFormErrors, openings: null});
                          }
                        }} 
                        className={`w-full px-3 py-2 border rounded-md ${jobFormErrors.openings ? 'border-red-500' : 'border-gray-300'}`} 
                      />
                      {jobFormErrors.openings && <p className="text-red-500 text-xs mt-1">{jobFormErrors.openings}</p>}
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Application Deadline *</label>
                      <input 
                        type="date" 
                        required 
                        min="2025-01-01" 
                        max="2099-12-31"
                        value={newJob.deadline} 
                        onChange={(e) => {
                          setNewJob({...newJob, deadline: e.target.value});
                          if (jobFormErrors.deadline) setJobFormErrors({...jobFormErrors, deadline: null});
                        }} 
                        className={`w-full px-3 py-2 border rounded-md ${jobFormErrors.deadline ? 'border-red-500' : 'border-gray-300'}`} 
                      />
                      {jobFormErrors.deadline && <p className="text-red-500 text-xs mt-1">{jobFormErrors.deadline}</p>}
                    </div>
                    <div className="sm:col-span-2">
                      <label className="block text-sm font-medium text-gray-700 mb-2">Job Description *</label>
                      <textarea 
                        required 
                        rows="3" 
                        maxLength="500"
                        value={newJob.description} 
                        onChange={(e) => {
                          setNewJob({...newJob, description: e.target.value});
                          if (jobFormErrors.description) setJobFormErrors({...jobFormErrors, description: null});
                        }} 
                        className={`w-full px-3 py-2 border rounded-md ${jobFormErrors.description ? 'border-red-500' : 'border-gray-300'}`} 
                      />
                      {jobFormErrors.description && <p className="text-red-500 text-xs mt-1">{jobFormErrors.description}</p>}
                      <p className="text-gray-400 text-xs mt-1">{newJob.description.length}/500 characters</p>
                    </div>
                    <div className="sm:col-span-2">
                      <label className="block text-sm font-medium text-gray-700 mb-2">Requirements (comma separated) *</label>
                      <input 
                        type="text" 
                        required 
                        maxLength="500"
                        value={newJob.requirements} 
                        onChange={(e) => {
                          setNewJob({...newJob, requirements: e.target.value});
                          if (jobFormErrors.requirements) setJobFormErrors({...jobFormErrors, requirements: null});
                        }} 
                        className={`w-full px-3 py-2 border rounded-md ${jobFormErrors.requirements ? 'border-red-500' : 'border-gray-300'}`} 
                      />
                      {jobFormErrors.requirements && <p className="text-red-500 text-xs mt-1">{jobFormErrors.requirements}</p>}
                      <p className="text-gray-400 text-xs mt-1">{newJob.requirements.length}/500 characters</p>
                    </div>
                  </div>
                  <div className="flex justify-end gap-3">
                    <button type="button" onClick={() => {
                      setShowJobForm(false);
                      setJobFormErrors({});
                    }} className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50">Cancel</button>
                    <button type="submit" disabled={isSubmitting} className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50">{isSubmitting ? 'Posting...' : 'Post Job'}</button>
                  </div>
                </form>
              </div>
            )}

            {/* Updated Job Table with better horizontal symmetry and text wrapping */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase w-1/5">Job Title</th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase w-1/6">Department</th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase w-1/6">Location</th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase w-1/6">Salary Range</th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase w-1/12">Type</th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase w-1/12">Openings</th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase w-1/12">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {jobs.map((job) => (
                      <tr key={job.id} className="hover:bg-gray-50 border-b border-gray-100">
                        <td className="px-4 py-4">
                          <div className="text-sm font-medium text-gray-900 break-words">{job.title}</div>
                          <div className="text-xs text-gray-500 break-words">{job.experience}</div>
                        </td>
                        <td className="px-4 py-4 text-sm text-gray-600 break-words">{job.department}</td>
                        <td className="px-4 py-4 text-sm text-gray-600 break-words">{job.location}</td>
                        <td className="px-4 py-4 text-sm text-gray-600 whitespace-nowrap">{formatCurrency(job.salaryMin)} - {formatCurrency(job.salaryMax)}</td>
                        <td className="px-4 py-4 text-sm text-gray-600">{job.type}</td>
                        <td className="px-4 py-4 text-sm text-gray-600">{job.openings}</td>
                        <td className="px-4 py-4"><span className={`px-2 py-1 text-xs rounded-full ${getStatusColor(job.status)}`}>{job.status}</span></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {/* Candidates Tab */}
        {activeTab === 'candidates' && (
          <div>
            <div className="mb-6 flex justify-end">
              <button onClick={() => setShowCandidateForm(!showCandidateForm)} className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 flex items-center gap-2"><span>+</span> Add Candidate</button>
            </div>

            {showCandidateForm && (
              <div className="bg-white rounded-lg shadow-md p-6 mb-6">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">Add New Candidate</h2>
                <form onSubmit={handleCandidateSubmit} className="space-y-4">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Full Name *</label>
                      <input type="text" required maxLength="100" value={newCandidate.name} onChange={(e) => {
                        setNewCandidate({...newCandidate, name: e.target.value});
                        if (candidateFormErrors.name) setCandidateFormErrors({...candidateFormErrors, name: null});
                      }} className={`w-full px-3 py-2 border rounded-md ${candidateFormErrors.name ? 'border-red-500' : 'border-gray-300'}`} />
                      {candidateFormErrors.name && <p className="text-red-500 text-xs mt-1">{candidateFormErrors.name}</p>}
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Email *</label>
                      <input type="email" required maxLength="100" value={newCandidate.email} onChange={(e) => {
                        setNewCandidate({...newCandidate, email: e.target.value});
                        if (candidateFormErrors.email) setCandidateFormErrors({...candidateFormErrors, email: null});
                      }} className={`w-full px-3 py-2 border rounded-md ${candidateFormErrors.email ? 'border-red-500' : 'border-gray-300'}`} />
                      {candidateFormErrors.email && <p className="text-red-500 text-xs mt-1">{candidateFormErrors.email}</p>}
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Phone * (10 digits)</label>
                      <input type="tel" required maxLength="10" pattern="\d{10}" value={newCandidate.phone} onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, '').slice(0, 10);
                        setNewCandidate({...newCandidate, phone: value});
                        if (candidateFormErrors.phone) setCandidateFormErrors({...candidateFormErrors, phone: null});
                      }} className={`w-full px-3 py-2 border rounded-md ${candidateFormErrors.phone ? 'border-red-500' : 'border-gray-300'}`} placeholder="9876543210" />
                      {candidateFormErrors.phone && <p className="text-red-500 text-xs mt-1">{candidateFormErrors.phone}</p>}
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Applying For *</label>
                      <select required value={newCandidate.position} onChange={(e) => setNewCandidate({...newCandidate, position: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-md">
                        <option value="">Select Position</option>
                        {jobs.filter(j => j.status === 'Open').map(job => <option key={job.id} value={job.title}>{job.title}</option>)}
                      </select>
                      {candidateFormErrors.position && <p className="text-red-500 text-xs mt-1">{candidateFormErrors.position}</p>}
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Experience *</label>
                      <input type="text" required maxLength="50" value={newCandidate.experience} onChange={(e) => {
                        setNewCandidate({...newCandidate, experience: e.target.value});
                        if (candidateFormErrors.experience) setCandidateFormErrors({...candidateFormErrors, experience: null});
                      }} className={`w-full px-3 py-2 border rounded-md ${candidateFormErrors.experience ? 'border-red-500' : 'border-gray-300'}`} placeholder="e.g., 4 years" />
                      {candidateFormErrors.experience && <p className="text-red-500 text-xs mt-1">{candidateFormErrors.experience}</p>}
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Current CTC (₹) *</label>
                      <input type="number" min="0" required value={newCandidate.currentCtc} onChange={(e) => {
                        setNewCandidate({...newCandidate, currentCtc: e.target.value});
                        if (candidateFormErrors.currentCtc) setCandidateFormErrors({...candidateFormErrors, currentCtc: null});
                      }} className={`w-full px-3 py-2 border rounded-md ${candidateFormErrors.currentCtc ? 'border-red-500' : 'border-gray-300'}`} />
                      {candidateFormErrors.currentCtc && <p className="text-red-500 text-xs mt-1">{candidateFormErrors.currentCtc}</p>}
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Expected CTC (₹) *</label>
                      <input type="number" min="0" required value={newCandidate.expectedCtc} onChange={(e) => {
                        setNewCandidate({...newCandidate, expectedCtc: e.target.value});
                        if (candidateFormErrors.expectedCtc) setCandidateFormErrors({...candidateFormErrors, expectedCtc: null});
                      }} className={`w-full px-3 py-2 border rounded-md ${candidateFormErrors.expectedCtc ? 'border-red-500' : 'border-gray-300'}`} />
                      {candidateFormErrors.expectedCtc && <p className="text-red-500 text-xs mt-1">{candidateFormErrors.expectedCtc}</p>}
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Skills (comma separated) *</label>
                      <input type="text" required maxLength="200" value={newCandidate.skills} onChange={(e) => {
                        setNewCandidate({...newCandidate, skills: e.target.value});
                        if (candidateFormErrors.skills) setCandidateFormErrors({...candidateFormErrors, skills: null});
                      }} className={`w-full px-3 py-2 border rounded-md ${candidateFormErrors.skills ? 'border-red-500' : 'border-gray-300'}`} placeholder="e.g., React, JavaScript" />
                      {candidateFormErrors.skills && <p className="text-red-500 text-xs mt-1">{candidateFormErrors.skills}</p>}
                    </div>
                  </div>
                  <div className="flex justify-end gap-3">
                    <button type="button" onClick={() => {
                      setShowCandidateForm(false);
                      setCandidateFormErrors({});
                    }} className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50">Cancel</button>
                    <button type="submit" disabled={isSubmitting} className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50">{isSubmitting ? 'Adding...' : 'Add Candidate'}</button>
                  </div>
                </form>
              </div>
            )}

            {/* Candidates Table - with text limiting to 100 characters */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase w-1/6">Candidate</th>
                      <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase w-1/6">Position</th>
                      <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase w-1/6">Round 1<br/><span className="text-xs font-normal">(2 hrs)</span></th>
                      <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase w-1/6">Round 2<br/><span className="text-xs font-normal">(2 hrs)</span></th>
                      <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase w-1/6">Round 3<br/><span className="text-xs font-normal">(2 hrs)</span></th>
                      <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase w-1/6">Round 4<br/><span className="text-xs font-normal">(2 hrs)</span></th>
                      <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase w-1/12">Status</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {candidates.map((candidate) => (
                      <tr key={candidate.id} className="hover:bg-gray-50">
                        <td className="px-3 py-4">
                          <div className="text-sm font-medium text-gray-900" title={candidate.name}>{truncateText(candidate.name, 100)}</div>
                          <div className="text-xs text-gray-500" title={candidate.email}>{truncateText(candidate.email, 100)}</div>
                          <div className="text-xs text-gray-500 mt-1" title={candidate.experience}>💼 {truncateText(candidate.experience, 100)}</div>
                        </td>
                        <td className="px-3 py-4 text-sm text-gray-600" title={candidate.position}>{truncateText(candidate.position, 100)}</td>
                        
                        {/* Round 1 */}
                        <td className="px-3 py-4">
                          <div className="space-y-1 min-w-[150px]">
                            <div className={`text-xs font-medium ${getRoundStatusColor(candidate.interviewRounds[0]?.status)}`}>
                              {candidate.interviewRounds[0]?.status || 'Pending'}
                            </div>
                            {candidate.interviewRounds[0]?.interviewerName && (
                              <div className="text-xs text-gray-500">
                                👤 {truncateText(candidate.interviewRounds[0].interviewerName, 100)}<br/>
                                <span className="text-gray-400">{truncateText(candidate.interviewRounds[0].interviewerDesignation, 100)}</span>
                              </div>
                            )}
                            {candidate.interviewRounds[0]?.date && (
                              <div className="text-xs text-gray-400">
                                📅 {candidate.interviewRounds[0].date} {candidate.interviewRounds[0].time}<br/>
                                ⏰ {candidate.interviewRounds[0].duration}
                              </div>
                            )}
                            {candidate.interviewRounds[0]?.status === 'Pending' && (
                              <button onClick={() => openScheduleModal(candidate, 1)} className="text-xs text-blue-600 hover:text-blue-800 mt-1 block">Schedule</button>
                            )}
                            {candidate.interviewRounds[0]?.status === 'Scheduled' && (
                              <button onClick={() => openFeedbackModal(candidate, 1)} className="text-xs text-green-600 hover:text-green-800 mt-1 block">Add Feedback</button>
                            )}
                            {candidate.interviewRounds[0]?.feedback && (
                              <div className="text-xs text-gray-500 mt-1">
                                ⭐ Score: {candidate.interviewRounds[0].feedback.averageScore?.toFixed(1)}/10
                              </div>
                            )}
                          </div>
                         </td>
                        
                        {/* Round 2 */}
                        <td className="px-3 py-4">
                          <div className="space-y-1 min-w-[150px]">
                            <div className={`text-xs font-medium ${getRoundStatusColor(candidate.interviewRounds[1]?.status)}`}>
                              {candidate.interviewRounds[1]?.status || 'Pending'}
                            </div>
                            {candidate.interviewRounds[1]?.interviewerName && (
                              <div className="text-xs text-gray-500">
                                👤 {truncateText(candidate.interviewRounds[1].interviewerName, 100)}<br/>
                                <span className="text-gray-400">{truncateText(candidate.interviewRounds[1].interviewerDesignation, 100)}</span>
                              </div>
                            )}
                            {candidate.interviewRounds[1]?.date && (
                              <div className="text-xs text-gray-400">
                                📅 {candidate.interviewRounds[1].date} {candidate.interviewRounds[1].time}<br/>
                                ⏰ {candidate.interviewRounds[1].duration}
                              </div>
                            )}
                            {candidate.interviewRounds[0]?.feedback?.status === 'Passed' && candidate.interviewRounds[1]?.status === 'Pending' && (
                              <button onClick={() => openScheduleModal(candidate, 2)} className="text-xs text-blue-600 hover:text-blue-800 mt-1 block">Schedule</button>
                            )}
                            {candidate.interviewRounds[1]?.status === 'Scheduled' && (
                              <button onClick={() => openFeedbackModal(candidate, 2)} className="text-xs text-green-600 hover:text-green-800 mt-1 block">Add Feedback</button>
                            )}
                          </div>
                         </td>
                        
                        {/* Round 3 */}
                        <td className="px-3 py-4">
                          <div className="space-y-1 min-w-[150px]">
                            <div className={`text-xs font-medium ${getRoundStatusColor(candidate.interviewRounds[2]?.status)}`}>
                              {candidate.interviewRounds[2]?.status || 'Pending'}
                            </div>
                            {candidate.interviewRounds[2]?.interviewerName && (
                              <div className="text-xs text-gray-500">
                                👤 {truncateText(candidate.interviewRounds[2].interviewerName, 100)}<br/>
                                <span className="text-gray-400">{truncateText(candidate.interviewRounds[2].interviewerDesignation, 100)}</span>
                              </div>
                            )}
                            {candidate.interviewRounds[2]?.date && (
                              <div className="text-xs text-gray-400">
                                📅 {candidate.interviewRounds[2].date} {candidate.interviewRounds[2].time}<br/>
                                ⏰ {candidate.interviewRounds[2].duration}
                              </div>
                            )}
                            {candidate.interviewRounds[1]?.feedback?.status === 'Passed' && candidate.interviewRounds[2]?.status === 'Pending' && (
                              <button onClick={() => openScheduleModal(candidate, 3)} className="text-xs text-blue-600 hover:text-blue-800 mt-1 block">Schedule</button>
                            )}
                            {candidate.interviewRounds[2]?.status === 'Scheduled' && (
                              <button onClick={() => openFeedbackModal(candidate, 3)} className="text-xs text-green-600 hover:text-green-800 mt-1 block">Add Feedback</button>
                            )}
                          </div>
                         </td>
                        
                        {/* Round 4 */}
                        <td className="px-3 py-4">
                          <div className="space-y-1 min-w-[150px]">
                            <div className={`text-xs font-medium ${getRoundStatusColor(candidate.interviewRounds[3]?.status)}`}>
                              {candidate.interviewRounds[3]?.status || 'Pending'}
                            </div>
                            {candidate.interviewRounds[3]?.interviewerName && (
                              <div className="text-xs text-gray-500">
                                👤 {truncateText(candidate.interviewRounds[3].interviewerName, 100)}<br/>
                                <span className="text-gray-400">{truncateText(candidate.interviewRounds[3].interviewerDesignation, 100)}</span>
                              </div>
                            )}
                            {candidate.interviewRounds[3]?.date && (
                              <div className="text-xs text-gray-400">
                                📅 {candidate.interviewRounds[3].date} {candidate.interviewRounds[3].time}<br/>
                                ⏰ {candidate.interviewRounds[3].duration}
                              </div>
                            )}
                            {candidate.interviewRounds[2]?.feedback?.status === 'Passed' && candidate.interviewRounds[3]?.status === 'Pending' && (
                              <button onClick={() => openScheduleModal(candidate, 4)} className="text-xs text-blue-600 hover:text-blue-800 mt-1 block">Schedule</button>
                            )}
                            {candidate.interviewRounds[3]?.status === 'Scheduled' && (
                              <button onClick={() => openFeedbackModal(candidate, 4)} className="text-xs text-green-600 hover:text-green-800 mt-1 block">Add Feedback</button>
                            )}
                          </div>
                         </td>
                        
                        <td className="px-3 py-4">
                          <span className={`px-2 py-1 text-xs rounded-full ${getStatusColor(candidate.status)}`}>
                            {candidate.status}
                          </span>
                         </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Schedule Interview Modal */}
      {showInterviewModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
            <div className="border-b border-gray-200 px-6 py-4">
              <h3 className="text-lg font-semibold text-gray-900">Schedule {interviewData.roundName}</h3>
              <p className="text-sm text-gray-500 mt-1">Candidate: {selectedCandidate?.name}</p>
            </div>
            <div className="p-6 space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Interviewer Name *</label>
                <input type="text" maxLength="100" value={interviewData.interviewerName} onChange={(e) => setInterviewData({...interviewData, interviewerName: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-md" placeholder="Enter interviewer name" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Interviewer Designation *</label>
                <input type="text" maxLength="100" value={interviewData.interviewerDesignation} onChange={(e) => setInterviewData({...interviewData, interviewerDesignation: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-md" placeholder="e.g., Technical Lead, HR Manager" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Interview Date * (2025-2026)</label>
                <input type="date" min="2025-01-01" max="2026-12-31" value={interviewData.date} onChange={(e) => setInterviewData({...interviewData, date: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-md" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Interview Time *</label>
                <input type="time" value={interviewData.time} onChange={(e) => setInterviewData({...interviewData, time: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-md" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Duration *</label>
                <input type="text" value={interviewData.duration} readOnly className="w-full px-3 py-2 border border-gray-200 rounded-md bg-gray-50" />
              </div>
            </div>
            <div className="border-t border-gray-200 px-6 py-4 flex justify-end gap-3">
              <button onClick={() => setShowInterviewModal(false)} className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50">Cancel</button>
              <button onClick={scheduleInterview} className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700">Schedule Interview</button>
            </div>
          </div>
        </div>
      )}

      {/* Feedback Form Modal */}
      {showFeedbackModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="border-b border-gray-200 px-6 py-4">
              <h3 className="text-lg font-semibold text-gray-900">Candidate Feedback Form</h3>
              <p className="text-sm text-gray-500">Candidate: {selectedCandidate?.name} | Round {currentFeedbackRound}</p>
            </div>
            <div className="p-6 space-y-4">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Technical Skills (1-10)</label>
                  <input type="number" min="1" max="10" value={feedbackData.technicalSkills} onChange={(e) => setFeedbackData({...feedbackData, technicalSkills: parseInt(e.target.value)})} className="w-full px-3 py-2 border border-gray-300 rounded-md" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Communication (1-10)</label>
                  <input type="number" min="1" max="10" value={feedbackData.communication} onChange={(e) => setFeedbackData({...feedbackData, communication: parseInt(e.target.value)})} className="w-full px-3 py-2 border border-gray-300 rounded-md" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Problem Solving (1-10)</label>
                  <input type="number" min="1" max="10" value={feedbackData.problemSolving} onChange={(e) => setFeedbackData({...feedbackData, problemSolving: parseInt(e.target.value)})} className="w-full px-3 py-2 border border-gray-300 rounded-md" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Attitude (1-10)</label>
                  <input type="number" min="1" max="10" value={feedbackData.attitude} onChange={(e) => setFeedbackData({...feedbackData, attitude: parseInt(e.target.value)})} className="w-full px-3 py-2 border border-gray-300 rounded-md" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Domain Knowledge (1-10)</label>
                  <input type="number" min="1" max="10" value={feedbackData.domainKnowledge} onChange={(e) => setFeedbackData({...feedbackData, domainKnowledge: parseInt(e.target.value)})} className="w-full px-3 py-2 border border-gray-300 rounded-md" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Overall Status *</label>
                  <select value={feedbackData.status} onChange={(e) => setFeedbackData({...feedbackData, status: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-md">
                    <option value="Passed">Passed</option>
                    <option value="Failed">Failed</option>
                  </select>
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Overall Comments</label>
                <input type="text" maxLength="200" value={feedbackData.overall} onChange={(e) => setFeedbackData({...feedbackData, overall: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-md" placeholder="Brief overall assessment" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Additional Comments</label>
                <textarea rows="3" maxLength="500" value={feedbackData.additionalComments} onChange={(e) => setFeedbackData({...feedbackData, additionalComments: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-md" placeholder="Any additional feedback or notes..." />
              </div>
            </div>
            <div className="border-t border-gray-200 px-6 py-4 flex justify-end gap-3">
              <button onClick={() => setShowFeedbackModal(false)} className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50">Cancel</button>
              <button onClick={submitFeedback} className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700">Submit Feedback</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Recruitment;